export default "__VITE_ASSET__CnDaTccJ__"